import { Box, Typography, Button, Paper, Container, Fade, Zoom } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import logo from '../../../assets/images/logo512x512-apple-touch.png';

/**
 * Pantalla de éxito de envío de trámite
 * Muestra mensaje de confirmación y número de trámite
 *
 * @param {Object} props
 * @param {string} props.idSolicitudCobertura - ID de la solicitud de cobertura generada
 * @param {Function} props.onReset - Función para reiniciar el formulario (opcional)
 */
const SubmitSuccessScreen = ({ idSolicitudCobertura = 0, onReset }) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 3,
        overflow: 'auto',
      }}
    >
      <Container maxWidth='sm'>
        <Fade in={true} timeout={800}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 3, sm: 5 },
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              borderRadius: 4,
              bgcolor: 'background.paper',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Logo */}
            <Box sx={{ mb: 6, height: 100 }}>
              <img src={logo} alt='IOSPER Logo' style={{ height: '100%', objectFit: 'contain' }} />
            </Box>

            {/* Título con Icono */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                mb: 2,
              }}
            >
              <Typography
                variant='h4'
                component='h1'
                fontWeight='700'
                sx={{ color: 'text.primary' }}
              >
                ¡Documentación cargada!
              </Typography>
            </Box>

            {/* Mensaje */}
            <Typography
              variant='body2'
              color='text.secondary'
              paragraph
              sx={{ mb: 4 }}
              fontSize={'1.125rem'}
            >
              La documentación se adjuntó de manera correcta al trámite seleccionado.
            </Typography>

            {/* ID del Trámite */}
            <Box
              sx={{
                bgcolor: 'action.hover',
                p: 2,
                borderRadius: 2,
                mb: 4,
                width: '100%',
              }}
            >
              <Zoom in={true} timeout={1000}>
                <CheckCircleIcon sx={{ fontSize: 40, color: 'success.main' }} />
              </Zoom>
              <Typography variant='subtitle2' color='text.secondary' gutterBottom>
                NÚMERO DE TRÁMITE
              </Typography>
              <Typography variant='h5' fontWeight='600' color='primary.main'>
                {idSolicitudCobertura}
              </Typography>
            </Box>

            {/* Botón de Acción (Opcional, si queremos permitir volver) */}
            {/* {onReset && (
              <Button
                variant="outlined"
                color="primary"
                onClick={onReset}
                sx={{ mt: 1 }}
              >
                Volver al inicio
              </Button>
            )} */}
          </Paper>
        </Fade>
      </Container>
    </Box>
  );
};

export default SubmitSuccessScreen;
